/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc-已审稿件
 */
'use strict';
angular.module("hasBeenModule", []).
controller('hasBeenCtrl', ['$scope','httpService','$q','$timeout','modalDialog','$filter', function($scope,httpService,$q,$timeout,modalDialog,$filter) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channelsOptions:[]
        }
        $scope.page = {
            "CURRPAGE": 0,
            "PAGESIZE": 20,
            "ITEMCOUNT": 0
        };
        $scope.allStatus = {
           '-1':'删除',
        	'0':'草稿',
        	'1':'待审核',
        	'2':'二次审核',
        	'3':'已签发',
        	'4':'已退稿'
        };
        $scope.allType = {
        	'0':'图文稿',
        	'1':'图集稿',
        	'2':'视频稿',
        	'3':'活动稿'
        };
        $scope.data = {
            listData: [],
        };
        $scope.params = {
            startTime: '',
            endTime: '',
        };
        addChildRefresh();//开始监听
    };

    function initData() {
        initDropDownList().then(function(){
            requestData();
        });
    };
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
    	var deffer = $q.defer();
        initChannelsList().then(function(data){
            var item = data.data;
            var allchannel = {
                name: "全部渠道",
                value: ''
            }
            $scope.status.channelsOptions.push(allchannel);
            for(var i=0;i<item.length;i++){
                var creatJSON = {};
                creatJSON.name = item[i].channelName;
                creatJSON.value = item[i].id;
                $scope.status.channelsOptions.push(creatJSON);
            }
            $scope.status.selectedchannels = angular.copy($scope.status.channelsOptions[0]);
            deffer.resolve();
        })
        return deffer.promise;
    };
    function initChannelsList(){
        var deferred = $q.defer();
        httpService.http("/mcnadmin/admin/auth/getAuthChannels.do","","post").then(function(data){
            deferred.resolve(data);
        })
        return deferred.promise;
    }
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };
    function requestData() {
        var params = {
            pubChannelId: $scope.status.selectedchannels.value,
            startTime: $scope.params.startTime,
            endTime: $scope.params.endTime,
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/checkedArticleList.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        });
    };
    /**
     * [queryByDropdown description] 筛选条件触发后请求数据
     * @param  {[type]} key   [description] 请求对象参数key
     * @param  {[type]} value [description] 请求对象值
     * @return {[type]}       [description] null
     */
    $scope.queryByDropdown = function() {
        $scope.params.startTime = $scope.status.startDate;
        $scope.params.endTime = $scope.status.endDate;
        requestData();
    };
	/**
     * [downlineArticle description]强制下线
     * @param  {[type]} key   [description] 稿件的id
     * @return {[type]} [description]
     */
  	
    $scope.downlineArticle = function(docId,channelId){
    	modalDialog.backConfirmModal("强制下线", "确认下线此文章？", function() {
	    	$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/downlineArticle.do", {articleId:docId,channelId:channelId}, "post").then(function(data) {
	    		modalDialog.alertType('','下线成功','success');
	    		requestData();
	        });
        });
    };
    
    /**
     * [addChildRefresh description] 监听子页面保存，并刷新本身
     */
    function addChildRefresh() {
        window.addEventListener("storage", function(e) {
            if (e.key === "ls.refresh") {
                requestData();
            }
        }, false);
    };
    /**
    * [dateFormat description] 时间格式化
	* @return {[type]} [description]
	 */
	$scope.dateFormat = function(time) {
		return $filter("date")(time, "yyyy-MM-dd HH:mm:ss").toString();
	};
}])
